"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.associateBy = exports.groupBy = void 0;
/**
 * Transforms an array of values, then groups them according to keys computed by a given function.
 * @param values the array of values to group.
 * @param key function for computing a key from a given value.
 * @param transform function for transforming values before grouping.
 */
function groupBy(values, key, transform) {
    const r = new Map();
    values.forEach((value) => {
        const k = key(value);
        if (!r.has(k))
            r.set(k, []);
        r.get(k).push(transform(value));
    });
    return r;
}
exports.groupBy = groupBy;
/**
 * Transforms an array of values, then associates them to unique keys computed by a given function.
 * @param values the array of values to associate to keys.
 * @param key function for computing a key from a given value.
 * @param transform function for transforming values before associating.
 */
function associateBy(values, key, transform) {
    const r = new Map();
    values.forEach((value) => {
        r.set(key(value), transform(value));
    });
    return r;
}
exports.associateBy = associateBy;
